import React from 'react';
import { ButtonSecondary } from '@creditas-ui/button';
import { useDrawer } from './useDrawer';

type ButtonMouseEvent = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;

const DrawerCloseButton = (): JSX.Element => {
  const { onClose } = useDrawer();

  return (
    <ButtonSecondary onClick={onClose as unknown as ButtonMouseEvent}>
      <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.334 9.334l13.333 13.333M22.667 9.334L9.333 22.666"
          stroke="#1F2D27"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </ButtonSecondary>
  );
};

export { DrawerCloseButton };
